export default __webpack_public_path__ + "static/media/at (2).f204b312.jpg";